import { SidebarIcon, type SidebarIconProps } from "./sidebar-icon";

export const SidebarOpenIcon = (props: SidebarIconProps) => (
  <SidebarIcon side="left" open={true} {...props} />
);
